import cptCmn from '@/mixin/cpt-cmn';
export default {
  name: 'QueryFilterCpt',
  mixins: [cptCmn],
  props: {},
  data() {
    return {
      show: false,
      codeResItems: [{
        title: '客户级别',
        dataIndex: 'customerLevelType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerLevelType',
        value: undefined
      }, {
        title: '客户类型',
        dataIndex: 'customerType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerType',
        value: undefined
      }, {
        title: '客户类别',
        dataIndex: 'customerCategoryType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerCategoryType',
        value: undefined
      }, {
        title: '获客方式',
        dataIndex: 'customerObtainWay',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerObtainWay',
        value: undefined
      }, {
        title: '客户重要性',
        dataIndex: 'customerImportType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerImportType',
        value: undefined
      }]
    };
  },
  methods: {
    showView() {
      this.show = true;
      this.initResCodeType(this.codeResItems).then(() => {
        for (const menu of this.codeResItems) {
          for (const item of menu.dataRes) {
            item.text = item[menu.dataResItem.title];
            item.value = item[menu.dataResItem.key];
          }
        }
      });
    },
    onClose() {
      this.$emit('onFilterChange', this.codeResItems);
    },
    onResetClick() {
      for (const menu of this.codeResItems) {
        menu.value = undefined;
      }
    }
  }
};